import './App.css';
import './fonts/SFPro/stylesheet.css';
import Home from './pages/Home';
import { useLayoutEffect, useState, useRef } from 'react';
import styled from 'styled-components';

import { Routes, Route } from 'react-router-dom';

import { ReactComponent as HeaderLogo } from "./images/logo.svg"
import { keyframes } from 'styled-components';
import { mq } from './components/util/media';
// import { Webapp } from './pages/Webapp';

const AppWrapper = styled.div`
  max-width: 1192px;
  margin: 0 auto;
  font-family: 'SFProDisplay', -apple-system, BlinkMacSystemFont, sans-serif;

  ${mq.lt.md} {
    max-width: 679px;
  }

  ${mq.lt.sm} {
    max-width: 326px;
  }
`

const Loader = styled.div`

  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: black;
  z-index: 9999;
  display: flex;
  justify-content: center;
  align-items: center;

`

//pulse animation
const Pulse = keyframes`
  0% {
    opacity: 0;
  }
  50% {
    opacity: 1;
  }
`

const PreloadInner = styled.div`
  transition: ease-in-out 1s;

  width: 100%;
  max-width: 110px;
  aspect-ratio: 1;

  & svg {
    width: 100%;
    height: 100%;

    fill: white;

    transition: all 1s ease-in-out;
    animation: ${Pulse} 3s ease-in-out alternate infinite;
  }

  &.fade-out {
    opacity: 0;
  }
`

function App() {

  const [ loading, setLoading ] = useState(true);

  const ref = useRef(null);
  const mainVideoRef = useRef(0);

  useLayoutEffect(() => {
    window.addEventListener('load', (event) => {

      var loaderInterval = setInterval(() => {
        console.log('check')
        if (mainVideoRef.current !== null) {
          window.scrollTo(0, 0); //chrome scrolls down sometimes?
          console.log('video exists now, loading is false')

          setTimeout(() => {
            ref.current.classList.add('fade-out')
          }, 1500);

          setTimeout(() => {
            setLoading(false);
          }, 2000);
        }

        clearInterval(loaderInterval);
      }, 200);
    });
  }, []);

  return (
    <AppWrapper>

      {loading && (
      <Loader>
        <PreloadInner ref={ref}>
          <HeaderLogo />
        </PreloadInner>
      </Loader>
      )}
      <Routes>
        <Route exact path='/' element={<Home loading={loading} mainVideoRef={mainVideoRef} />}></Route>
        {/* <Route exact path='/webapp' element={<Webapp loading={loading} mainVideoRef={mainVideoRef} />}></Route> */}
      </Routes>

     
    </AppWrapper>
  );
}

export default App;
